module.exports = __webpack_public_path__ + "img/undraw_social_influencer_sgsv.8a9850d9.svg";